import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import { eUSAState } from '../../ui-toolkit/enums/states';
import { ICountyData } from '../../ui-toolkit/orders/searchOrder/types/ICounty';

export interface ICountiesState {
  counties: ICountiesData;
  countiesFetchStatus: IFetchStatus;
  countiesError: string | null;
}

export type ICountiesData = Record<eUSAState, ICountyData[]>;
export const defaultCounties = (): ICountiesData =>
  Object.keys(eUSAState).reduce((previous, key) => {
    previous[key] = [];
    return previous;
  }, {}) as ICountiesData;

export const countiesInitialState: ICountiesState = {
  counties: defaultCounties(),
  countiesFetchStatus: createDefaultFetch(),
  countiesError: null,
};
